import React from 'react';
import Investor from '../../models/Investor';

export interface InvestorContextType {
  investors: Investor[] | null;
  refreshInvestor: (id: string) => void;
  loading: () => boolean;
}

const InvestorContext = React.createContext<InvestorContextType>({
  investors: null,
  refreshInvestor: () => {},
  loading: () => false,
});

export default InvestorContext;
